<template>
  <div class="wapper">
    <el-container>
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline"
            >
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.phone"
                      placeholder="手机"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.code"
                      placeholder="码值"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.company"
                      placeholder="公司"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.groupNo"
                      placeholder="团组"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.label"
                      placeholder="标签"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.remark"
                      placeholder="备注"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-select placeholder="是否支付：" v-model="searchForm.pay">
                    <el-option value="-1" label="全部支付"></el-option>
                    <el-option value="0" label="未支付"></el-option>
                    <el-option value="1" label="已支付"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-select placeholder="是否主办审核：" v-model="searchForm.verify">
                    <el-option value="-1" label="全部主办审核"></el-option>
                    <el-option value="0" label="未审核"></el-option>
                    <el-option value="1" label="已审核"></el-option>
                    <el-option value="2" label="审核不通过"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-select placeholder="是否公安审核：" v-model="searchForm.disabled">
                    <el-option value="-1" label="全部公安审核"></el-option>
                    <el-option value="0" label="未审核"></el-option>
                    <el-option value="1" label="已审核"></el-option>
                    <el-option value="2" label="审核不通过"></el-option>
                    <el-option value="3" label="无效身份证"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="!group">
                  <el-select
                      placeholder="团组："
                      v-model="searchForm.groupUserId"
                      class="el-input-position"
                  >
                    <el-option
                        label="全部团组"
                        value="0"
                    ></el-option>
                    <el-option
                        v-for="(item, index) in groupUsers"
                        :key="index"
                        :label="item.name"
                        :value="item.groupUserId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-select
                      placeholder="注册类型："
                      v-model="searchForm.type"
                      class="el-input-position"
                  >
                    <el-option
                        v-for="(item, index) in types"
                        :key="index"
                        :label="item.name"
                        :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-select
                      placeholder="证件类型："
                      v-model="searchForm.documentTypeId"
                      class="el-input-position"
                  >
                    <el-option
                        label="全部证件类型"
                        value="0"
                    ></el-option>
                    <el-option
                        v-for="(item, index) in DocumentType"
                        :key="index"
                        :label="item.name"
                        :value="item.documentTypeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-select
                      placeholder="注册通道："
                      clearable
                      v-model="searchForm.registerId"
                      class="el-input-position"
                  >
                    <el-option
                        label="全部注册通道"
                        value="0"
                    ></el-option>
                    <el-option
                        v-for="(item, index) in registers"
                        :key="index"
                        :label="item.name"
                        :value="item.registerId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-date-picker
                      v-model="searchForm.startDate"
                      type="datetime"
                      placeholder="开始日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label>
                  <el-date-picker
                      v-model="searchForm.endDate"
                      type="datetime"
                      placeholder="开始日期"
                  ></el-date-picker>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit()"
                >搜索
                </el-button
                >
                <el-button
                    type="primary"
                    icon="el-icon-export"
                    @click="exportExcel()"
                >导出
                </el-button
                >
                <el-tag v-if="label"><b>{{ label }}</b></el-tag>
                <div class="uers-right">
                <span class="btn-r">
                  <el-button
                      v-if="!isPublic"
                      type="success"
                      plain
                      icon="el-icon-pay"
                      @click="pay"
                  >支付
                  </el-button>
                  <el-button
                      v-if="!gb"
                      type="success"
                      plain
                      icon="el-icon-pay"
                      @click="notPay"
                  >取消支付
                  </el-button>
                <el-button
                    v-if="roles!=='公安人员'"
                    v-show="!isPublic"
                    type="primary"
                    plain
                    icon="el-icon-verify"
                    @click="verify(1)"
                >主办审核
                </el-button>
                <el-button
                    v-if="roles!=='公安人员'"
                    v-show="!isPublic"
                    type="warning"
                    plain
                    icon="el-icon-verify"
                    @click="verify(0)"
                >取消审核
                </el-button>
                <el-button
                    v-if="roles!=='公安人员'"
                    v-show="!isPublic"
                    type="danger"
                    plain
                    icon="el-icon-verify"
                    @click="verify(2)"
                >审核不通过
                </el-button>
                <el-button
                    type="primary"
                    plain
                    v-if="roles==='公安人员'|| roles==='超级管理员'||isPublic"
                    icon="el-icon-verify"
                    @click="publicVerify(1)"
                >公安审核
                </el-button>
                <el-button
                    type="warning"
                    plain
                    v-if="roles==='公安人员'|| roles==='超级管理员'||isPublic"
                    icon="el-icon-verify"
                    @click="publicVerify(0)"
                >取消公安审核
                </el-button>
                    <el-button
                        type="danger"
                        plain
                        v-if="roles==='公安人员'|| roles==='超级管理员'||isPublic"
                        icon="el-icon-verify"
                        @click="publicVerify(2)"
                    >公安审核不通过
                </el-button>
                  <el-button
                      type="primary"
                      v-show="!isPublic"
                      plain
                      icon="el-icon-plus"
                      @click="addSubmit"
                  >新增</el-button>
                  <!--                  <el-button-->
                  <!--                    type="primary"-->
                  <!--                    plain-->
                  <!--                    icon="el-icon-remove"-->
                  <!--                    @click="deleteSubmit"-->
                  <!--                    >根据批次号删除</el-button-->
                  <!--                  >-->
                </span>
                  <el-popover
                      placement="bottom"
                      title="批量导入"
                      width="220"
                      trigger="click"
                  >
                    <div>
                      <el-upload
                          class="upload-demo"
                          :action="action"
                          :auto-upload="false"
                          :on-change="uploadChange"
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      >
                        <el-button size="small" type="primary"
                        >选择导入模板
                        </el-button
                        >
                      </el-upload>
                      <el-button
                          type="success"
                          @click="download"
                          plain
                          icon="el-icon-download"
                          class="down-template"
                      >下载模板
                      </el-button
                      >
                    </div>
                    <p class="import-text">只能选择 .xls .xlsx 文件</p>
                    <div>
                      <el-button v-if="!isPublic" type="success" @click="importData"
                      >新增
                      </el-button>
                      <el-button v-if="!isPublic" type="success" @click="importUpdateData"
                      >修改
                      </el-button>
                      <el-button v-if="isPublic" type="success" @click="importDataVerify"
                      >公安审核状态
                      </el-button>
                    </div>
                    <el-button
                        type="primary"
                        plain
                        icon="el-icon-upload2"
                        slot="reference"
                    >导入人员
                    </el-button
                    >
                  </el-popover
                  >&nbsp;&nbsp;&nbsp;
                  <el-popover
                      placement="bottom"
                      title="批量导入身份证"
                      width="220"
                      trigger="click"
                  >
                    <div>
                      <el-upload
                          class="upload-demo"
                          :action="action"
                          :auto-upload="false"
                          :on-change="upload"
                          :file-list="fileList"
                          :limit="1"
                          :on-success="handleSuccess"
                          :on-exceed="handleExceed"
                          accept=".zip,.rar"
                      >
                        <el-button size="small" type="primary"
                        >选择压缩包
                        </el-button
                        >
                      </el-upload>
                    </div>
                    <el-button
                        type="primary"
                        plain
                        icon="el-icon-upload2"
                        slot="reference"
                    >导入身份证图片
                    </el-button
                    >
                  </el-popover>
                  &nbsp;
                </div>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="avatar"
                  width="60"
                  label="头像"
                  align="center"
              >
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.avatar"
                        :preview-src-list="[scope.row.avatar]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="avatar"
                  width="60"
                  label="凭证"
                  align="center"
              >
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.url"
                        :preview-src-list="[scope.row.url]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  width="80"
                  label="姓名"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  width="80"
                  label="类型"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.documentType }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="phone"
                  width="120"
                  label="手机/车牌"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.phone }}</p>
                  <p>{{ scope.row.carNo }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="email"
                  width="100"
                  label="备注/分论坛"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.remark }}</p>
                  <p>{{ scope.row.market }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="idCard"
                  width="150"
                  label="证件号码"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.idCard }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="company" label="公司/职位" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.company }}{{ scope.row.position }}</span><br/>
                  <span>{{ scope.row.companyEn }}{{ scope.row.positionEn }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="position"
                  width="160"
                  label="地址"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.province }} {{ scope.row.city }} {{ scope.row.area }}</p>
                  <p>{{ scope.row.address }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="isSign"
                  width="50"
                  label="支付"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.pay ? "是" : "否" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="50"
                  prop="pay"
                  label="领队"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.leader === 1 ? "是" : "否" }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="verify"
                  width="80"
                  label="主办审核"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{
                      scope.row.verify === 1 ? "已审核" : scope.row.verify === 0 ? "未审核" : "审核不通过"
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="disabled"
                  width="80"
                  label="公安审核"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{
                      scope.row.disabled === 1 ? "已审核" : scope.row.disabled === 0 ? "未审核" : scope.row.disabled === 2 ? "审核不通过" : "身份证无效"
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  width="150"
                  label="创建时间"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button
                      v-show="roles!=='公安人员'&&roles!=='夜值人员'"
                      v-if="(scope.row.verify===0 || roles!=='业务员') "
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button>
                  <el-button
                      v-show="roles!=='公安人员'&&roles!=='夜值人员'"
                      v-if="!isPublic"
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditExhibitorsPersonal
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditExhibitorsPersonal>
        <el-dialog :visible.sync="dialogVisible" width="400px" style=" text-align: center;"
                   :before-close="handleClose">
          <div class="flex-box">
            <div>微信支付二维码</div>
            <div class="qr-code" ref="qrCodeUrl"/>
          </div>
          <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditExhibitorsPersonal from "../../components/major/EditExhibitorsPersonal";
import DeleteDialog from "../../components/public/DeleteConfim";
import {log} from "util";
import axios from "axios";
import QRCode from 'qrcodejs2';

var types = [
  {name: "全部类型", value: "0"},
  {name: "组委会", value: "1"},
  {name: "展商", value: "2"},
  {name: "展团/代表团", value: "3"},
  {name: "观众", value: "4"},
  {name: "媒体", value: "5"},
  {name: "嘉宾", value: "6"},
  {name: "搭建商", value: "7"},
  {name: "服务商", value: "8"},
  {name: "撤展人员", value: "9"},
  {name: "兼职/志愿者/外协", value: "10"},
  {name: "会议/论坛/活动", value: "11"},
  {name: "其他", value: "12"},
];

export default {
  data() {
    return {
      fileList: [],
      qrcode: '',
      dialogVisible: false,
      group: localStorage.getItem("roles") === "团组",
      isPublic: localStorage.getItem("roles") === "公安审核人员",
      roles: localStorage.getItem("roles"),
      right: localStorage.getItem("roles").indexOf("业务员") > -1,
      label: localStorage.getItem("roles").indexOf("业务员") > -1 ? "您的登录用户还没有被添加为注册来源" : "",
      gb: window.location.href.indexOf('/gb') > 0,
      total: 0, //总条数
      currentPage: 1, //初始页
      pageSize: 10, // 每页的数据
      searchForm: {
        groupUserId: "0",
        documentTypeId: "0",
        groupNo: "",
        name: "",
        phone: "",
        type: "0",
        pay: "-1",
        verify: "-1",
        disabled: "-1",
        code: "",
        label: "",
        remark: "",
        company: "",
        endDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 - 1
        ),
        startDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() -
            (new Date(new Date().toLocaleDateString()).getTime() -
                new Date(new Date().getFullYear().toString()))
        ),
        registerId: "0",
      },
      uploadUrl: "",
      uploadDate: "",
      types: types,
      DocumentType: [],
      registers: [],
      groupUsers: [],
      action: localStorage.getItem("url"),
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      personal_Id: "",
      groupUserId: localStorage.getItem("roles") === "团组" ? localStorage.getItem("groupUserId") : null,
    };
  },
  created() {
    this.getData();
    this.loadData();
  },
  methods: {
    getDocumentType() {
      this.$axios.get("/DocumentType/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.DocumentType = [...res.data.data];
        }
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    loadData() {
      this.getDocumentType();

      this.$axios
          .get("/Register/Project/" + this.projectId)
          .then((res) => {
            if (res.data.hasError == false) {
              this.registers = [...res.data.data];
            } else {
              console.log(res.data.message);
            }
          })
          .catch(function () {
          });

      this.$axios
          .get("/GroupUser/" + this.projectId)
          .then((res) => {
            if (res.data.hasError == false) {
              this.groupUsers = [...res.data.data];
            } else {
              console.log(res.data.message);
            }
          })
          .catch(function () {
          });

      this.$axios
          .get("/Source/Phone/" + this.projectId + "," + localStorage.getItem("ms_username"))
          .then((res) => {
            if (res.data.hasError == false) {
              this.label = res.data.data.url;
            } else {
              console.log(res.data.message);
            }
          })
          .catch(function () {
          });
    },
    downloadFile(data) {
      if (!data) {
        return;
      }
      const link = document.createElement("a");
      let blob = new Blob([data], {type: "application/vnd.ms-excel"});
      link.style.display = "none";
      link.href = URL.createObjectURL(blob);

      link.setAttribute("download", "记录信息" + ".xls");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    verify(verify) {
      let codes = [];
      this.$refs.multipleTable.selection.forEach((element) => {
        if (verify === 0 && element.pay === true) {
          this.$message.error("已支付的人员不能取消审核！");
          throw Error();
        }
        codes.push(element.personalId);
      });
      if (this.$refs.multipleTable.selection.length > 0) {
        let opt = verify === 0 ? "取消审核" : "审核";
        this.$confirm("是否" + opt + "选中行？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$axios.put(`/Personal/Verify/${verify}`, codes).then((res) => {
            if (res.data.hasError) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success(opt + "成功！");
              this.getData();
            }
          });
        }).catch(() => {
        });
      } else {
        this.$message.error("请选择需要操作的行");
      }
    },
    publicVerify(verify) {
      let codes = [];
      this.$refs.multipleTable.selection.forEach((element) => {
        codes.push(element.personalId);
      });
      if (this.$refs.multipleTable.selection.length > 0) {
        let opt = verify === 0 ? "取消审核" : "审核";
        this.$confirm("是否" + opt + "选中行？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$axios.put(`/Personal/Disabled/${verify}`, codes).then((res) => {
            if (res.data.hasError) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success(opt + "成功！");
              this.getData();
            }
          });
        }).catch(() => {
        });
      } else {
        this.$message.error("请选择需要操作的行");
      }
    },
    pay() {
      if (this.$refs.multipleTable.selection.length > 0) {
        let codes = [];
        if (this.gb) {
          this.$refs.multipleTable.selection.forEach((element) => {
            if (!element.pay) {
              if (element.verify === 0) {
                this.$message.error("主办未审核的人员不能进行支付！");
                throw Error();
              }
              if (element.disabled === 0 && element.type === 8) {
                this.$message.error("公安未审核的人员不能进行支付！");
                throw Error();
              }
              codes.push(element.personalId);
            }
          });
          if (codes.length > 0) {
            this.$confirm("是否生成选中行的支付吗？", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              this.dialogVisible = true;
              this.$axios.put(`/Personal/Pay/` + this.projectId, codes).then((res) => {
                if (res.data.hasError) {
                  this.$message.error(res.data.message);
                } else {
                  this.qrcode = res.data.data;
                  this.$refs.qrCodeUrl.innerHTML = "";
                  new QRCode(this.$refs.qrCodeUrl, {
                    text: res.data.data, // 二维码的内容
                    width: 300,
                    height: 300,
                    colorDark: '#000',
                    colorLight: '#fff'
                  });
                }
              });
            }).catch(() => {
            });
          } else {
            this.$message.error("请选择的行都已支付");
          }
        } else {
          this.$refs.multipleTable.selection.forEach((element) => {
            if (!element.pay) {
              codes.push(element.personalId);
            }
          });

          if (codes.length > 0) {
            this.$confirm("是否支付选中行的吗？", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              this.$axios.put(`/Personal/pay/true`, codes).then((res) => {
                if (res.data.hasError) {
                  this.$message.error(res.data.message);
                } else {
                  this.getData();
                }
              });
            }).catch(() => {
            });
          } else {
            this.$message.error("请选择的行都已支付");
          }
        }
      } else {
        this.$message.error("请选择需要支付的行");
      }
    },
    notPay() {
      if (this.$refs.multipleTable.selection.length > 0) {
        let codes = [];
        if (this.gb) {
        } else {
          this.$refs.multipleTable.selection.forEach((element) => {
            if (element.pay) {
              codes.push(element.personalId);
            }
          });
          if (codes.length > 0) {
            this.$confirm("是否取消支付选中行的吗？", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              this.$axios.put(`/Personal/pay/false`, codes).then((res) => {
                if (res.data.hasError) {
                  this.$message.error(res.data.message);
                } else {
                  this.getData();
                }
              });
            }).catch(() => {
            });
          } else {
            this.$message.error("请选择的行都已支付");
          }
        }
      } else {
        this.$message.error("请选择需要支付的行");
      }
    },
    exportExcel() {
      var search = {
        groupNo: this.searchForm.groupNo,
        groupUserId: this.group ? localStorage.getItem("groupUserId") : this.searchForm.groupUserId,
        name: this.searchForm.name,
        pageIndex: 0,
        pageSize: this.total,
        phone: this.searchForm.phone,
        code: this.searchForm.code,
        exhibitorId: 0,
        label: this.searchForm.label,
        remark: this.searchForm.remark,
        documentTypeId: this.searchForm.documentTypeId,
        company: this.searchForm.company,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        projectId: this.projectId,
        batch: this.right ? localStorage.getItem("accountId") : "",
        type: this.roles === "夜值人员" ? "8" : this.searchForm.type,
        pay: this.searchForm.pay,
        verify: this.searchForm.verify,
        disabled: this.searchForm.disabled,
        registerId: this.searchForm.registerId == "" ? 0 : parseInt(this.searchForm.registerId),
      };
      //this.$axios.post(`/Personal/Export`,search,{responseType: 'blob'}).then(res => {
      // this.downloadFile(res)
      //})
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
          .post(`/Personal/Export`, search)
          .then((res) => {
            loading.close();
            if (res.data.data) {
               window.open(res.data.data, '_self');
              // this.$download(res.data.data, '导出证件.xlsx');
            } else {
              this.$message.error("导出不通过");
            }
          })
          .catch((a) => {
            loading.close();
            this.$message.error("导出不通过");
          });
    },
    //  文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.$message.warning("文件已移除");
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    handleExceed() {
      //提示最多只能上传1个
      this.$message.warning("最多上传1个文件！");
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    upload(file, fileList) {
      this.file = event.currentTarget.files[0];
      const limitSize = 1024 * 1024 * 100;
      if (this.file.size > limitSize) {
        alert("文件大小不能超过100MB");
      }
      let formData = new FormData();
      formData.append('file', this.file);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios.post("/Upload/File?eId=" + this.projectId, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        if (res.data.hasError == false) {
          this.$message.success(res.data.message)
        } else {
          this.$message.error('操作失败')
        }
        loading.close();
        this.fileList = this.fileList.slice(-1);
      }).catch((e) => {
        this.$message.error("操作失败");
        loading.close();
      });
    },
    uploadChange(file, fileList) {
      let inputDOM = this.$refs.inputer; // 通过DOM取文件数据
      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var formData = new FormData();
      formData.append("file", f);

      this.$axios
          .post("/Upload/File", formData, {
            headers: {"Content-Type": "multipart/form-data"},
          })
          .then((resp) => {
            this.uploadUrl = resp.data.data;
            this.uploadDate = resp.data.message;

            var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
            FileReader.prototype.readAsBinaryString = function (f) {
              var binary = "";
              var rABS = false; //是否将文件读取为二进制字符串
              var pt = this;
              var wb; //读取完成的数据
              var outdata;
              var reader = new FileReader();
              reader.onload = function (e) {
                var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for (var i = 0; i < length; i++) {
                  binary += String.fromCharCode(bytes[i]);
                }
                var XLSX = require("xlsx");
                if (rABS) {
                  wb = XLSX.read(btoa(fixdata(binary)), {
                    //手动转化
                    type: "base64",
                  });
                } else {
                  wb = XLSX.read(binary, {
                    type: "binary",
                  });
                } // outdata就是你想要的东西 excel导入的数据
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
                let ar = [];
                outdata.map((v) => {
                  let obj = {};
                  obj.personalId = v.ID;
                  obj.name = v.姓名;
                  obj.nameEn = v.英文姓名;
                  obj.sex = v.性别称呼;
                  obj.email = v.邮箱;
                  obj.avatar = v.头像;
                  obj.company = v.公司;
                  obj.companyEn = v.公司英文;
                  obj.position = v.职务;
                  obj.idCard = v.证件号码;
                  obj.phone = v.手机号码;
                  obj.area = v.地区号码;
                  obj.countryArea = v.国家地区;
                  obj.province = v.省份;
                  obj.city = v.城市;
                  obj.address = v.地址;
                  obj.addressEn = v.英文地址;
                  obj.code = v.码值;
                  obj.booth = v.展位号;
                  obj.status = v.审核状态;
                  obj.phoneNo = v.移动电话;
                  obj.construction = v.施工证类型;
                  obj.electrician = v.施工证;
                  obj.carUrl = v.行驶证照片;
                  obj.carNo = v.车牌号;
                  obj.electricianUrl = v.施工证照片;
                  obj.idCardUrl = v.身份证照片;
                  obj.lang = v.语言;
                  obj.openId = v.标签;
                  obj.source = v.来源;
                  obj.positionEn = v.职务英文;
                  obj.remark = v.备注;
                  obj.remark1 = v.备注1;
                  obj.remark2 = v.备注2;
                  obj.remark3 = v.备注3;
                  obj.remark4 = v.备注4;
                  obj.remark5 = v.备注5;
                  obj.addressEn = v.地址英文;
                  obj.documentType = v.证件类型;
                  obj.market = v.分论坛;
                  obj.business = v.业务范围;
                  obj.profile = v.业务类型;
                  obj.visit = v.参展目的;
                  if (!obj.visit) {
                    obj.visit = v.座位号;
                  }
                  if (!obj.profile) {
                    obj.profile = v.行政级别;
                  }
                  obj.department = v.有效证件类型;
                  obj.groupNo = v.团组;
                  obj.isReception = v.是否接机;
                  obj.arrivalLocation = v.抵达地点;
                  obj.arrivalMethod = v.抵达方式;
                  obj.arrivalGrades = v.抵达班次;
                  obj.arrivalDate = v.抵达日期;
                  obj.arrivalTime = v.抵达时间;
                  obj.receivedName = v.接机人;
                  obj.receivedPhone = v.接机人手机;
                  obj.receivedCarNo = v.接机车牌;
                  obj.receivedCar = v.接机车型;
                  obj.isReceived = v.是否接到;
                  obj.receivedTime = v.接到时间;
                  obj.isGive = v.是否送机;
                  obj.giveDate = v.接机日期;
                  obj.giveTime = v.送机时间;
                  obj.giveLocation = v.送机地点;
                  obj.giveMethod = v.送机方式;
                  obj.giveGrades = v.送机班次;
                  obj.giveName = v.送机人;
                  obj.givePhone = v.送机人手机;
                  obj.giveCar = v.送机人车型;
                  obj.giveCarNo = v.送机人车牌;
                  obj.isDelivery = v.是否送达;
                  obj.deliveryTime = v.送达时间;
                  obj.isCheckIn = v.是否入住酒店;
                  obj.hotel = v.酒店名称;
                  obj.roomType = v.房间类型;
                  obj.roomNo = v.房间号;
                  obj.departureTime = v.离开酒店时间;
                  obj.checkInTime = v.入住酒店时间;
                  obj.batch = localStorage.getItem("accountId");
                  obj.groupUserId = this.groupUserId;
                  ar.push(obj);
                });
                localStorage.setItem("attr", JSON.stringify(ar));
              };
              reader.readAsArrayBuffer(f);
            };
            if (rABS) {
              reader.readAsArrayBuffer(f);
            } else {
              reader.readAsBinaryString(f);
            }
          });
    },
    importData() {
      if (this.searchForm.registerId != "" && this.searchForm.registerId != "0") {
        this.attr = JSON.parse(localStorage.getItem("attr"));
        if (this.attr && this.attr.length > 0) {
          this.$axios
              .post("/ProjectFile/", {
                projectId: this.projectId,
                documentTypeId: this.searchForm.registerId,
                url: this.uploadUrl,
                name: "操作人-" + localStorage.getItem('ms_username'),
                code: this.uploadDate,
                remark: "新增人员，项目-" + localStorage.getItem('project'),
              })
              .then((res) => {
                if (res.data.hasError == false) {
                  const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                  });
                  let url = "/Personal/" + this.searchForm.registerId;
                  if (window.location.hostname.indexOf("gb") > -1) {
                    url = '/gb' + url;
                  }
                  this.$axios
                      .patch(url, this.attr)
                      .then((res) => {
                        if (res.data.hasError == false) {
                          loading.close();
                          this.searchSubmit();
                          localStorage.setItem("attr", null);
                          this.$message.success(res.data.message);
                        } else {
                          this.$message.error(res.data.message);
                          loading.close();
                        }
                      })
                      .catch(function () {
                        loading.close();
                      });
                }
              })
              .catch(function () {
                loading.close();
              });
        } else {
          this.$message.error("没有可上传的数据");
        }
      } else {
        this.$message.error("请选择注册通道");
      }
    }, importUpdateData() {
      this.attr = JSON.parse(localStorage.getItem("attr"));
      if (this.attr && this.attr.length > 0) {
        this.$axios
            .post("/ProjectFile/", {
              projectId: this.projectId,
              documentTypeId: this.searchForm.registerId,
              url: this.uploadUrl,
              name: "操作人-" + localStorage.getItem('ms_username'),
              code: this.uploadDate,
              remark: "编辑人员，项目-" + localStorage.getItem('project'),
            })
            .then((res) => {
              if (res.data.hasError == false) {
                const loading = this.$loading({
                  lock: true,
                  text: "Loading",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)",
                });
                let url = "/Personal/" + this.projectId;

                this.$axios
                    .post(url, this.attr)
                    .then((res) => {
                      if (res.data.hasError == false) {
                        loading.close();
                        this.searchSubmit();
                        localStorage.setItem("attr", null);
                        this.$message.success(res.data.message);
                      } else {
                        this.$message.error(res.data.message);
                        loading.close();
                      }
                    })
                    .catch(function () {
                      loading.close();
                    });
              }
            })
            .catch(function () {
              loading.close();
            });
      } else {
        this.$message.error("没有可上传的数据");
      }
    }, importDataVerify() {
      this.attr = JSON.parse(localStorage.getItem("attr"));
      if (this.attr && this.attr.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let url = "/Personal/publicVerify/";
        this.$axios
            .post(url, this.attr)
            .then((res) => {
              if (res.data.hasError == false) {
                loading.close();
                this.searchSubmit();
                localStorage.setItem("attr", null);
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
                loading.close();
              }
            })
            .catch(function () {
              loading.close();
            });
      } else {
        this.$message.error("没有可上传的数据");
      }
    },
    download() {
      var url = localStorage.getItem("url");
      if (url.lastIndexOf("/api") == url.indexOf("/api")) {
        if (this.roles == '公安审核人员') {
          window.open(url.replace("/api", "/") + "/data/公安审核模版.xlsx");
        } else if (window.location.hostname.indexOf("gb") > -1) {
          window.open(url.replace("/api", "/") + "/data/人员导入模板.xlsx");
        } else {
          window.open(url.replace("/api", "/") + "/data/用户模板.xlsx");
        }
      } else {
        if (window.location.hostname.indexOf("gb") > -1) {
          window.open(
              url.substring(0, url.lastIndexOf("/api")) +
              "/data/人员导入模板.xlsx"
          );
        } else {
          window.open(
              url.substring(0, url.lastIndexOf("/api")) +
              "/data/用户模板.xlsx"
          );
        }
      }

    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    deleteSubmit() {
      if (!this.searchForm.batch) {
        this.$message.error("请输入批次号！");
        return;
      }
      this.$axios
          .delete(`/Personal/batch/${this.projectId}/${this.searchForm.batch}`)
          .then((res) => {
            if (res.data.hasError) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success("删除成功！");
              this.delVisible = false;
            }
          });
    },
    addSubmit() {
      this.personal_Id = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    handleDelete(index, row) {
      this.personal_Id = row.personalId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.personal_Id = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios.delete(`/Personal/${this.personal_Id}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    // 获取数据
    getData() {
      var search = {
        groupNo: this.searchForm.groupNo,
        groupUserId: this.group ? localStorage.getItem("groupUserId") : this.searchForm.groupUserId,
        name: this.searchForm.name,
        pageIndex: this.currentPage - 1,
        pageSize: this.pageSize,
        phone: this.searchForm.phone,
        code: this.searchForm.code,
        exhibitorId: 0,
        label: this.searchForm.label,
        remark: this.searchForm.remark,
        documentTypeId: this.searchForm.documentTypeId,
        company: this.searchForm.company,
        batch: this.right ? localStorage.getItem("accountId") : "",
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        projectId: this.projectId,
        type: this.searchForm.type,
        pay: this.searchForm.pay,
        verify: this.searchForm.verify,
        disabled: this.searchForm.disabled,
        registerId: this.searchForm.registerId === "" ? 0 : parseInt(this.searchForm.registerId),
      };
      this.$axios.post("/Personal/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  }
  ,
  components: {
    EditExhibitorsPersonal,
    DeleteDialog,
  }
  ,
}
;
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.qr-code {
  text-align: center;
  vertical-align: center;
  margin-top: 20px;
  background-color: #fff;
}

.flex-box {
  text-align: center;
  vertical-align: center;
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
  margin: 10px 10px 10px 10px;
}

.uers-import {
  margin-right: 30px;
  float: right;
  width: 240px;
}

.upload-excel {
  float: left;
}

.import-bnt {
  float: right;
}

.el-upload {
  height: 32px !important;
  line-height: 32px !important;
  width: 120px !important;
}

.el-upload--text {
  border: 0;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.import-text {
  margin: 15px 0;
}

.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}

.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}
</style>